import "./App.css";
import InteractiveGlobeComponent from "./component/interactive-globe-component";

function App() {
  return (
    <>
      <div className="text-white font-bold flex justify-center items-center h-32 text-3xl font-mono">
        Creating Interactive Globe
      </div>
      <InteractiveGlobeComponent />
    </>
  );
}

export default App;
